// extracted by mini-css-extract-plugin
var _1 = "vH7dn";
export { _1 as "error-banner" }
